import {
    getApiBarberProfileQueryKey,
    getApiBarberShiftIdQueryKey,
    usePostApiBarberShiftStatus,
} from '@barbershop/api/barber'
import { useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export const useResumeCurrentShift = (shiftId: number) => {
    const queryClient = useQueryClient()

    const { mutateAsync: resumeCurrentShift, isPending } = usePostApiBarberShiftStatus({
        mutation: {
            onSuccess: async () => {
                await Promise.all([
                    queryClient.invalidateQueries({
                        queryKey: getApiBarberShiftIdQueryKey(shiftId),
                    }),
                    queryClient.invalidateQueries({
                        queryKey: getApiBarberProfileQueryKey(),
                    }),
                ])
                toast.success('Смена успешно возобновлена')
            },
            onError: () => {
                toast.error('Ошибка при возобновлении смены')
            },
        },
    })

    return {
        resumeCurrentShift,
        isPending,
    }
}
